<h2>{{'Bibliography' | translate}}</h2>

<ul>
  @for (literature of literatureList; track $index) {
    <li [innerHTML]="literature"></li>
  }
</ul>